import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import LinkComponent, { LinkSizes, LinkTypes } from '@lib/components/Link/Link';
import { BaseItem, CellProps } from '@lib/components/Table/types';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import useTextCroppedTooltip from '@lib/hooks/useTextCroppedTooltip';
import styles from './TextLinkCell.module.scss';

interface Props {
  to?: string;
}

function TextLinkCell<T extends BaseItem>(props: Props & CellProps<T>) {
  const { disabled, value, onClick, to } = props;
  const { ref: textRef, isTooltipDisabled } =
    useTextCroppedTooltip<HTMLDivElement>(value);

  return (
    <div>
      <Tooltip body={value} disabled={isTooltipDisabled}>
        <LinkComponent
          component={NavLink}
          onClick={onClick}
          to={to}
          type={LinkTypes.tertiaryBlack}
          underline={false}
          size={LinkSizes.small}
          data-test-id="table__text-link"
          className={classNames(styles.rootTextCell, {
            [styles.disabled]: disabled,
          })}
        >
          <div ref={textRef} className={styles.croppedText}>
            {value}
          </div>
        </LinkComponent>
      </Tooltip>
    </div>
  );
}

export default memo(TextLinkCell) as <T extends BaseItem>(
  props: CellProps<T> & Props,
) => React.ReactElement;
